import { WpActivity } from './wp-activity.model';

export class WpPayment {
  constructor(
      public id?: number,
      public paymentMonth?: any,
      public paymentAmount?: any,
      public paymentRequestDt?: any,
      public uasCd?: string,
      public entitlementCd?: string,
      public expenseJustification?: any,
      public requestingUserId?: any,
      public paymentStatus?: any,
      public serviceAddrCountyCd?: any,
      public caseApproverSigDt?: any,
      public caseApproverFirstName?: string,
      public caseApproverMiddleName?: string,
      public caseApproverLastName?: string,
      public supApproverSigDt?: any,
      public supApproverFirstName?: any,
      public supApproverMiddleName?: any,
      public supApproverLastName?: any,
      public paymentModeCd?: any,
      public paymentReasonCd?: any,
      public paymentReasonComment?: any,
      public wpActivity?: WpActivity,
      public wpPayee?: any,
      public wpVendor?: any,
      public lastIssueDt?: any,

  ) {
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/model/wp-payment.model.ts